import { css } from '@emotion/react'

const logo = theme => css`
  padding: ${theme.spacing[6]};
`

export const styles = {
  logo,
}
